// export const categoryDict = {
//   Tea: { el: "Τσάι", en: "Tea" },
//   Soda: { el: "Αναψυκτικά", en: "Soda" },
//   Juice: { el: "Χυμοί", en: "Juice" },
//   Coffee: { el: "Καφές", en: "Coffee" },
//   "Other Beverages": { el: "Άλλα Ροφήματα", en: "Other Beverages" },
//   Bread: { el: "Ψωμί", en: "Bread" },
//   Pastries: { el: "Γλυκά", en: "Pastries" },
//   "Other Bakery Goods": { el: "Άλλα Αρτοσκευάσματα", en: "Other Bakery Goods" },
//   Milk: { el: "Γάλα", en: "Milk" },
//   Cheese: { el: "Τυρί", en: "Cheese" },
//   Yogurt: { el: "Γιαούρτι", en: "Yogurt" },
//   "Other Dairy Goods": { el: "Άλλα Γαλακτοκομικά προιόντα", en: "Other Dairy Goods" },
//   Meat: { el: "Κρέας", en: "Meat" },
//   Seafood: { el: "Θαλασσινά", en: "Seafood" },
//   Fruits: { el: "Φρούτα", en: "Fruits" },
//   Vegetables: { el: "Λαχανικά", en: "Vegetables" },
//   Frozen: { el: "Κατεψυγμένα", en: "Frozen" },
//   "Salty Snacks": { el: "Αλμυρά Σνακ", en: "Salty Snacks" },
//   "Sweet Snacks": { el: "Γλυκά Σνακ", en: "Sweet Snacks" },
//   "Other Snacks": { el: "Άλλα Σνακ", en: "Other Snacks" },
//   Canned: { el: "Κονσέρβες", en: "Canned" },
//   //Laundry: { el: "Πλυντήριο", en: "Laundry" },
//   "Cleaning Supplies": { el: "Καθαριστικά", en: "Cleaning Supplies" },
//   "Dish Cleaning Supplies": { el: "Προϊόντα Πλύσης Πιάτων", en: "Dish Cleaning Supplies" },
//   "Other Household": { el: "Άλλα Οικιακά", en: "Other Household" },
//   "Hair Care": { el: "Περιποίηση Μαλλιών", en: "Hair Care" },
//   "Personal Care": { el: "Προσωπική Φροντίδα", en: "Personal Care" },
//   //"Health Care": { el: "Υγειονομική Φροντίδα", en: "Health Care" },
//   PetFood: { el: "Τροφή Κατοικιδίων", en: "PetFood" },
//   Other: { el: "Άλλα", en: "Other" },
// };

export const translateCategory = (categoryName, lang) => {
  return categoryDict[categoryName]?.[lang] || categoryName;
};

export const translateText = async (text, fromLang, toLang) => {
  try {
    const response = await fetch(
      `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${fromLang}|${toLang}`
    );
    const data = await response.json();
    return data.responseData.translatedText;
  } catch (error) {
    console.error("Translation error:", error);
    return text;
  }
};